import { useEffect, useRef, useState } from "react"

import { motion } from "framer-motion";

import images from "../libs/images"
import consts from "../libs/consts"

import { uniqueId } from "lodash";

export default function Selector(props) {
    const {
        className = "",
        options = [],
        value,
        setValue,
        placeholder = "선택"
    } = props;

    const dropRef = useRef(null);

    const [focus, setFocus] = useState(false)
    const [label, setLabel] = useState(placeholder)

    useEffect(() => {
        let values = options?.map(v => v.value);
        if (values?.indexOf(value) >= 0) setLabel(options[values.indexOf(value)]?.label);
    }, [value])

    useEffect(() => {
        const handleClick = (e) => {
            if (dropRef.current && !dropRef.current.contains(e.target)) {
                setFocus(false);
            }
        };
        window.addEventListener('mouseup', handleClick);
        return () => {
            window.removeEventListener('mouseup', handleClick)
        };
    }, [dropRef])

    useEffect(() => {
        return () => {
        }
    }, [])

    return (
        <div ref={dropRef} className={`drop-box ${focus && "focus"} ${className}`} onClick={() => {
            setFocus(!focus);
        }}>
            {label}
            <motion.div
                className='drop-list'
                initial={consts.loaderVariants.closed}
                animate={focus ? "open" : "closed"}
                variants={consts.loaderVariants}
            >
                {options.map((v, i) => {
                    return <div key={uniqueId() + i} className="item" onClick={() => {
                        if (setValue) setValue(v?.value);
                        setLabel(v?.label);
                    }}>{v.label}</div>
                })}
            </motion.div>

            {/* {focus && <div className="drop-list">
                {options.map((v, i) => {
                    return <div key={uniqueId() + i} className="item" onClick={() => {
                        if (setValue) setValue(v?.value);
                        setLabel(v?.label);
                    }}>{v.label}</div>
                })}
            </div>} */}

        </div>
    )

} 